<template>
  <div class="store">
    <Header v-if="!notFound"></Header>
    <Menu v-if="showMenu || !notFound" :menuItems="menuItems" v-on:get-sort="getSortBy"></Menu>
    <MenuMobile class="d-block d-lg-none" :menuItems="menuItems" v-on:get-sort="getSortBy"></MenuMobile>
    <ProductsCategory
      :products="products"
      :productSlug="productSlug"
      v-on:get-product-slug="getProductSlug"
      :fetching="fetching"
      v-if="!notFound"
    ></ProductsCategory>
    <div class="container" v-if="!notFound">
      <div class="row" v-if="total > perPage">
        <div class="col-12 text-center mt-5">
          <ul class="list-inline">
            <li class="list-inline-item">
              <button
                @click.prevent="getProducts(previousPage, sort)"
                class="btn btn-lg btn-dutche-violet"
                :disabled="previousPage == ''"
              >
                <i class="fa fa-arrow-left"></i> Previous
              </button>
            </li>
            <li class="list-inline-item">
              <button
                @click.prevent="getProducts(nextPage, sort)"
                class="btn btn-lg btn-dutche-violet"
                :disabled="nextPage == ''"
              >
                Next <i class="fa fa-arrow-right"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <NotFound v-if="notFound"></NotFound>
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/store/Header.vue";
import ProductsCategory from "@/components/store/ProductsCategory.vue";
import Menu from "@/components/store/Menu";
import MenuMobile from "@/components/store/MenuMobile";
import NotFound from "@/views/404";

export default {
  name: "ProductsByCategory",
  components: {
    Header,
    ProductsCategory,
    Menu,
    MenuMobile,
    NotFound,
  },
  data() {
    return {
      products: undefined,
      menuItems: undefined,
      showMenu: false,
      nextPage: null,
      previousPage: null,
      perPage: 0,
      total: 0,
      fetching: false,
      notFound: false,
      productSlug: "",
      sort: '',
    };
  },
  mounted() {
    this.getProducts(1);
  },
  methods: {
    getProducts(page, sort = 0) {
      this.fetching = true;
      const parts = window.location.pathname.split("/");
      const category = parts.pop() || parts.pop();
      let path = `/store/products/${category}?&sort=${sort}`;
      if (page > 1) {
        path = `/store/products/${category}?page=${page}&sort=${sort}`;
      }

      axios.get(path).then((response) => {
        if (!response.data.success) {
          this.notFound = true;
          return;
        }
        this.products = response.data.products.data;
        this.menuItems = response.data.menuItems;
        this.showMenu = true;
        this.perPage = response.data.products.per_page;
        this.total = response.data.products.total;
        this.nextPage =
          response.data.products.current_page !==
          response.data.products.last_page
            ? response.data.products.current_page + 1
            : "";
        this.previousPage =
          response.data.products.current_page !== 1
            ? response.data.products.current_page - 1
            : "";
        this.fetching = false;
      }).catch(() => {
        this.notFound = true;
      });
    },
    getProductSlug(slug) {
      this.productSlug = slug;
    },
    getSortBy(sort) {
      this.sort = sort;
      this.getProducts(1, sort);
    }
  },
};
</script>


<style lang="sass" scoped>
.btn-dutche-violet
  text-transform: uppercase
  border-radius: 15px
  background-color: $dutche-primary-violet
  color: $white
  padding: 0.5rem 1rem
  width: 180px
</style>
